<template>
  <div class="popup">
    <div class="close" @click="close"><ios-close-icon /></div>
    <div class="row m-0 h-100 w-100 justify-content-center align-items-center">
      <div class="col-12 col-sm-11 col-md-6 col-lg-5 col-xl-4">
        <div class="popup_inner">
          <div class="row m-0 ">
            <div class="col-12 align-self-center p-0" >
              <form id="twostep-form" role="form" style="display: block;" class="white_bg p-4">
                <div class="row m-0 form_holder p-0">
                  <div class="col-12 mb-3 p-0 pb-3 border-bottom">
                    <div class="row m-0 align-items-center">
                      <div class="col p-0">
                        <h4 class="mb-0">Two Factor Authentication</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row m-0 form_holder p-0">
                  <div class="col-12 p-0">
                    <div class="form-group">
                      <label for="name">Enter the Two Factor Authentication code sent to your listed phone number</label>
                      <input
                        type="text"
                        name="OTP"
                        id="otp"
                        class="form-control"
                        placeholder="OTP"
                        v-model="otp"
                        required
                      />
                    </div>
                    <div class="form-group my-4 text-center small" v-if="showResend">
                      <span v-if="resent">New OTP sent</span>
                      <span v-else @click="resendOTP" class="cursor">Resend OTP</span>
                    </div>
                    <div class="form-group mt-4">
                      <div class="text-center pb-3" v-if="message" >{{message}}</div>
                      <button class="btn btn-primary w-100" disabled v-if="isSent">
                        Verifying...
                      </button>
                      <button class="btn btn-primary w-100" @click="verify" :disabled="!otp" v-else>
                        Verify
                      </button>
                    </div>
                    <div class="form-group mt-2">
                      <button class="btn btn-secondary w-100" disabled v-if="isSent">
                        Cancel
                      </button>
                      <button class="btn btn-secondary w-100" @click="close" v-else>
                        Cancel
                      </button>
                    </div>
                    <div class="error_text text-center mb-1" v-if="hasError">{{errorMsg}}</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['mobile'],
  data () {
    return {
      otp: null,
      message: '',
      hasError: false,
      isSent: false,
      errorMsg: '',
      resent: false,
      showResend: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.showResend = true
    }, 30000)
  },
  methods: {
    ...mapActions(['verifyTheOTP', 'sendTheOTP']),
    goTo (val) {
      this.$emit('goTo', val)
    },
    close () {
      this.$emit('close')
    },
    async resendOTP () {
      this.resent = true
      await this.sendTheOTP(this.mobile)
      setTimeout(() => {
        this.resent = false
      }, 8000)
    },
    async verify () {
      this.isSent = true
      const result = await this.verifyTheOTP({ mobile: this.mobile, otp: this.otp })
      if (!result.data.verified) {
        this.isSent = false
        this.hasError = true
        this.errorMsg = 'There was an issue with the authentication code you entered, please try again.'
      } else {
        this.isSent = true
        this.$emit('verified')
      }
    }
  }
}
</script>
<style scoped>
label {
  margin-bottom: 0;
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.popup_inner {
  max-height: 80vh;
  overflow-y: auto;
}
.close {
  color: #fff;
  opacity: 1;
  cursor: pointer;
  position: absolute;
  right: 0;
}
</style>
